<div class="flow-resume">
  <div class="flow-resume__container">
    <h2>Resumen de la póliza</h2>

    <!-- User Information Section -->
    @if (user()) {
      <div class="flow-resume__section">
        <app-user-resume [user]="user()!" />
      </div>
    }

    <!-- Insurable Data Section -->
    @if (insurableItems().length > 0) {
      <div class="flow-resume__section">
        <div class="insurance__wrapper">
          <h3>Datos del asegurable</h3>
          @for (item of insurableItems(); track item.title) {
            @if (item.text && item.text !== 'null' && item.text !== '') {
              <app-resume-item
                [title]="item.title"
                [text]="item.text"
              />
            }
          }

          <!-- Detail component slot (PA insured/clauses, TG carrier, etc.) -->
          <ng-container #detailContainer></ng-container>
        </div>
      </div>
    }

    <!-- Coverage Information Section -->
    @if (selectedCoverage()) {
      <div class="flow-resume__section">
        <div class="insurance__wrapper">
          <h3>Cobertura seleccionada</h3>

          <app-resume-item
            [title]="'Plan'"
            [text]="selectedCoverage()?.title || ''"
          />


          @if (coverageTotal()) {
            <app-resume-item
              [title]="'Total a pagar'"
              [text]="coverageTotal()"
            />
          }

          @if ((selectedCoverage()?.items?.length ?? 0) > 0) {
            <div class="insurance__wrapper mt-5">
              <strong>Coberturas incluidas</strong>
              <div class="flex flex-wrap gap-2 mt-2">
                @for (item of selectedCoverage()!.items!; track item.name) {
                  <span class="chip__base">{{ item.name }} 

                    @if (item.insuredCapital) {
                      <div class="font-semibold text-sm ml-2">
                        {{
                          (item?.insuredCapital) ?? 0
                            | currencyFormat: 'ARS'
                        }}
                      </div>
                    }
                  </span>
                }
              </div>
            </div>
          }
        </div>
      </div>
    }

    <!-- Additional Coverage Section -->
    @if (additionalCoverage()) {
      <div class="flow-resume__section">
        <div class="insurance__wrapper">
          <h3>Cobertura adicional</h3>

          <app-resume-item
            [title]="'Plan adicional'"
            [text]="additionalCoverage()?.title || ''"
          />

          @if (additionalCoverage()?.description) {
            <app-resume-item
              [title]="'Descripción'"
              [text]="additionalCoverage()!.description!"
            />
          }

          @if (additionalCoverageTotal()) {
            <app-resume-item
              [title]="'Costo adicional'"
              [text]="additionalCoverageTotal()"
            />
          }
        </div>
      </div>
    }


     <!-- Referral Code Section -->
    @if (showReferralCode() && quoteInfo()?.id) {
      <div class="flow-resume__section">
        <div class="insurance__wrapper">
          <activar-referral-code-banner
            [quoteId]="quoteInfo()!.id!"
            (codeApplied)="referralCodeChanged.emit($event)"
            (validating)="referralCodeValidating.emit($event)"
          />
        </div>
      </div>
    }
   
    
  </div>
</div>
